module.exports = __webpack_public_path__ + "static/media/roo_wor_mew.f6e0fcc8.png";